import * as Types from "../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateCurrencyBookLiquidityLimitsMutationVariables = Types.Exact<{
  objects: Array<Types.Currency_Book_Liquidity_Limits_Insert_Input>;
}>;

export type UpdateCurrencyBookLiquidityLimitsMutation = {
  __typename?: "mutation_root";
} & {
  insert_currency_book_liquidity_limits?: Types.Maybe<
    { __typename?: "currency_book_liquidity_limits_mutation_response" } & Pick<
      Types.Currency_Book_Liquidity_Limits_Mutation_Response,
      "affected_rows"
    >
  >;
};

export const UpdateCurrencyBookLiquidityLimitsDocument = gql`
  mutation UpdateCurrencyBookLiquidityLimits(
    $objects: [currency_book_liquidity_limits_insert_input!]!
  ) {
    insert_currency_book_liquidity_limits(
      objects: $objects
      on_conflict: {
        constraint: currency_book_liquidity_limits_currency_book_id_notice_days_lt_
        update_columns: [lower_limit_pct, upper_limit_pct]
      }
    ) {
      affected_rows
    }
  }
`;

export function useUpdateCurrencyBookLiquidityLimitsMutation() {
  return Urql.useMutation<
    UpdateCurrencyBookLiquidityLimitsMutation,
    UpdateCurrencyBookLiquidityLimitsMutationVariables
  >(UpdateCurrencyBookLiquidityLimitsDocument);
}
